"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Button_1 = __importDefault(require("components/design-system/Button"));
const Footer = ({ linkButtonDisabled, linkButton, linkButtonName, datacy, linkButtonDataCy, save, secondaryButton, buttonPrimaryName, buttonPrimaryDisabled, handleRoute, handleClick, style, customClass = '', customClassContainer = '', customButtonContainer, children, isButtonPrimaryLoading }) => {
    const [buttonPrimaryLoading, setButtonPrimaryLoading] = (0, react_1.useState)(false);
    const handleClickButtonPrimary = () => __awaiter(void 0, void 0, void 0, function* () {
        setButtonPrimaryLoading(true);
        handleClick && (yield handleClick());
        setButtonPrimaryLoading(false);
    });
    return (react_1.default.createElement("div", { className: `footer-container-shared ${customClassContainer}`, style: style },
        react_1.default.createElement("div", { className: `${customClass}` },
            children,
            react_1.default.createElement("div", { className: `flex justify-center items-center float-right ${customButtonContainer
                    ? customButtonContainer
                    : 'py-[14px] pr-[32px]'}` },
                secondaryButton && (react_1.default.createElement(Button_1.default.Secondary, { customClass: "mr-[8px]", onMouseDown: () => handleRoute && handleRoute(), disabled: linkButtonDisabled, datacy: linkButtonDataCy }, (0, HelperUtils_1.getObjectiveLocale)(linkButtonName))),
                linkButton && (react_1.default.createElement(Button_1.default.Tertiary, { customClass: "mr-[8px]", onMouseDown: () => handleRoute && handleRoute(), disabled: linkButtonDisabled }, (0, HelperUtils_1.getObjectiveLocale)(linkButtonName))),
                react_1.default.createElement(Button_1.default, { customClass: "footer-button-shared", onMouseDown: handleClickButtonPrimary, datacy: datacy, disabled: buttonPrimaryDisabled, isLoading: buttonPrimaryLoading || isButtonPrimaryLoading }, (0, HelperUtils_1.getObjectiveLocale)(save ? 'Save' : buttonPrimaryName ? buttonPrimaryName : 'Submit'))))));
};
exports.default = Footer;
